import { render, staticRenderFns } from "./CheckInput.vue?vue&type=template&id=1b30f275&scoped=true&"
import script from "./CheckInput.vue?vue&type=script&lang=js&"
export * from "./CheckInput.vue?vue&type=script&lang=js&"
import style0 from "./CheckInput.vue?vue&type=style&index=0&id=1b30f275&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b30f275",
  null
  
)

/* custom blocks */
import block0 from "./CheckInput.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports